import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import type { ActiveUnpaidOrderConflict } from "@/domain/order/active-unpaid-order"

/**
 * Checkout session gate state (not UX phase — see checkoutUx).
 * activeUnpaidOrder is set from order-checkout 4091; never from finalBilling hydration.
 */
interface CheckoutState {
  activeUnpaidOrder: ActiveUnpaidOrderConflict | null
}

const initialState: CheckoutState = {
  activeUnpaidOrder: null,
}

export const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setActiveUnpaidOrder: (state, action: PayloadAction<ActiveUnpaidOrderConflict | null>) => {
      state.activeUnpaidOrder = action.payload
    },
    clearActiveUnpaidOrder: (state) => {
      state.activeUnpaidOrder = null
    },
  },
})

export const { setActiveUnpaidOrder, clearActiveUnpaidOrder } = checkoutSlice.actions
export default checkoutSlice.reducer
